export enum IInfoSubsection {
  Info,
  Audit
}